/* eslint-disable no-shadow */
export enum DnsRecordsQueryKeys {
  GetAll = 'dnsRecords/getAll',
  GetOneById = 'dnsRecords/getById',
  Create = 'dnsRecords/create',
  Edit = 'dnsRecords/edit',
  Delete = 'dnsRecords/delete',
  Autocomplete = 'dnsRecords/autocomplete',
  Breadcrumb = 'dnsRecords/breadcrumb'
}
